// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3LH2D","imageUploader":"EGiftCard_imageUploader__174yh"};